import _ from 'lodash';
import SensorVariable from '@/models/SensorVariable';

export default {

  state: {

    stationList: [],

    stationObservations: [],

  },

  mutations: {

    SET_STATION_LIST(state, value) {
      state.stationList = value;
    },

    SET_STATION_OBSERVATIONS(state, value) {
      state.stationObservations = value;
    },

  },

  actions: {

    initializeStationObservations({ rootState, state, commit }, { data, range }) {
      const options = rootState.universal.appOptions;
      const variables = _.pull(Object.keys(data.timeseries.STATION[0].SENSOR_VARIABLES), 'date_time');

      commit('SET_STATION_OBSERVATIONS', variables.map(varName => (new SensorVariable({
        data,
        range,
        variable: varName,
        options,
      }))));
    },

  },

};



// WEBPACK FOOTER //
// ./src/store/station/index.js